import { BsCheckBox } from 'react-icons/bs';
import * as React from 'react';
export default {
  BsCheckBox,
  React
};